import { FormAsyncSelect } from './FormAsyncSelect'
import FormCheckbox from './FormCheckbox'
import { FormColorSelect } from './FormColorSelect'
import { FormDynamicFieldGroup } from './FormDynamicFieldGroup'
import FormInput from './FormInput'
import FormRoot from './FormRoot'
import FormTreeSelect from './FormTreeSelect'

const FormAntd = {
  Root: FormRoot,
  Input: FormInput,
  Checkbox: FormCheckbox,
  TreeSelect: FormTreeSelect,
  DynamicFieldGroup: FormDynamicFieldGroup,
  ColorSelect: FormColorSelect,
  AsyncSelect: FormAsyncSelect,
}

export default FormAntd
